




































import { Component, Vue } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'

import {
  SettingsForm,
  ConfirmLeaveModal,
  NetworkErrorEmptyState,
  VsLoading
} from '@/components'

import { MobileLayout } from '@/layouts/components'

import {
  ActionButton,
  AsyncState,
  ShopSettings,
  ShopSettingsResourcePayload,
  ModalState
} from '@/models'

@Component({
  components: {
    SettingsForm,
    ConfirmLeaveModal,
    MobileLayout,
    NetworkErrorEmptyState,
    VsLoading
  }
})
export default class Settings extends Vue {
  isReady = false

  loadState = new AsyncState()
  createOrUpdateState = new AsyncState()
  confirmLeaveState = new ModalState()

  data: ShopSettingsResourcePayload | null = null
  isValid = false

  get buttons (): ActionButton[] {
    if (!this.loadState.isResolved) {
      return []
    }

    return [
      {
        text: 'Salvar',
        handler: this.handleSubmit,
        isDisabled: !this.hasChanges || !this.isValid || this.createOrUpdateState.isPending
      }
    ]
  }

  get hasChanges () {
    const data = this.data
    const shopSettings = this.shopSettings

    if (shopSettings === null) {
      const test = data && (data.menuType !== null)
      return test
    }

    const test = data !== null && shopSettings !== null &&
      (data.menuType !== shopSettings.menuType)
    return test
  }

  @State
  readonly shopSettings!: ShopSettings | null

  @Action
  loadShopSettings!: () => Promise<void>

  @Action
  createOrUpdateShopSettings!: (payload: ShopSettingsResourcePayload) => Promise<void>

  async created () {
    if (this.shopSettings === null) {
      await this.reload()
    } else {
      this.loadState.touch()
    }
    if (this.shopSettings !== null) {
      this.data = {
        menuType: this.shopSettings.menuType
      }
    }

    this.isReady = true
  }

  async reload () {
    try {
      await this.loadState.handle(
        this.loadShopSettings()
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleSubmit () {
    if (this.data === null || !this.hasChanges || !this.isValid) {
      return
    }

    try {
      await this.createOrUpdateState.handle(
        this.createOrUpdateShopSettings(this.data)
      )
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível alterar.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  handleGoBack () {
    if (this.hasChanges) {
      this.confirmLeaveState.isActive = true
    } else {
      this.$router.back()
    }
  }
}
